// This file is automatically generated. Do not edit manually.

import { ProjectActivityResource } from "src/api/generated/erp/db/types/tables/projectActivityResource";
import { ProjectActivityResourceAppUserView } from "src/api/generated/erp/db/types/tables/projectActivityResourceAppUserView";
import { ErpAppUser } from "src/api/generated/erp/db/types/tables/erpAppUser";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProjectActivityResourcesApi {
	export async function getProjectActivityResourceOptions(): Promise<Array<ProjectActivityResource>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/getProjectActivityResourceOptions",
			method: "POST",
			data: {},
		});
		return response as Array<ProjectActivityResource>;
	}

	export async function getActivityResources(args: {
		showInactiveResources?: boolean;
	}): Promise<Array<ProjectActivityResource>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/getActivityResources",
			method: "POST",
			data: {
				showInactiveResources: args.showInactiveResources,
			},
		});
		return response as Array<ProjectActivityResource>;
	}

	export async function insert(args: { activityResource: ProjectActivityResource }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/insert",
			method: "POST",
			data: {
				activityResource: args.activityResource,
			},
		});
		return response as number;
	}

	export async function update(args: { activityResource: ProjectActivityResource }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/update",
			method: "POST",
			data: {
				activityResource: args.activityResource,
			},
		});
		return response as void;
	}

	export async function delete_(args: { activityResourceId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/delete",
			method: "POST",
			data: {
				activityResourceId: args.activityResourceId,
			},
		});
		return response as void;
	}

	export async function getResourceUsers(args: {
		activityResourceId: number;
	}): Promise<Array<ProjectActivityResourceAppUserView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/getResourceUsers",
			method: "POST",
			data: {
				activityResourceId: args.activityResourceId,
			},
		});
		return response as Array<ProjectActivityResourceAppUserView>;
	}

	export async function getAvailableUsersForResource(args: {
		activityResourceId: number;
	}): Promise<Array<ErpAppUser>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/getAvailableUsersForResource",
			method: "POST",
			data: {
				activityResourceId: args.activityResourceId,
			},
		});
		return response as Array<ErpAppUser>;
	}

	export async function connectUsersToResource(args: {
		activityResourceId: number;
		appUserIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/connectUsersToResource",
			method: "POST",
			data: {
				activityResourceId: args.activityResourceId,
				appUserIds: args.appUserIds,
			},
		});
		return response as void;
	}

	export async function setUserAsDefault(args: { activityResourceId: number; appUserId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/setUserAsDefault",
			method: "POST",
			data: {
				activityResourceId: args.activityResourceId,
				appUserId: args.appUserId,
			},
		});
		return response as void;
	}

	export async function deleteResourceUsers(args: {
		projectActivityResourceAppUserIds: Array<number>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityResources/deleteResourceUsers",
			method: "POST",
			data: {
				projectActivityResourceAppUserIds: args.projectActivityResourceAppUserIds,
			},
		});
		return response as void;
	}
}
